import React from "react";
import "./FriendMotivationalBanner.css";
import * as CONSTANT from "constants/text";
import TextTheme from "components/General/Text/TextTheme";
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import BlockUser from "components/Tribe/Friends/BlockUser.js";
import CustomDecisionPopup from "components/General/Form/Popup/CustomDecisionPopup";
import { Fragment } from "react";

class FriendMotivationalBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayCancelWarning: false,
      displayDeclineWarning: false,
      //These 3 checks are used to set the invite button to inactive if this request is already pending
      //It prevents users from trying to POST an existing friend request. The backend will already no allow it.
      buttonClassName: !this.props.inviteDisabled
        ? "background_light_med_grey"
        : "background_dark_orange",
      inviteTitle: !this.props.inviteDisabled
        ? CONSTANT.INVITE_SENT
        : CONSTANT.INVITE,
      requestTitle: !this.props.inviteDisabled
        ? CONSTANT.REQUEST_SENT
        : CONSTANT.REQUEST_TO_JOIN,
      buttonDisabled: !this.props.inviteDisabled || false,
    };
    //function binding declarations
    this.onDeclineClicked = this.onDeclineClicked.bind(this);
    this.onExitPopup = this.onExitPopup.bind(this);
    this.onCancelClicked = this.onCancelClicked.bind(this);
    this.onInviteClicked = this.onInviteClicked.bind(this);
    this.onRequestClicked = this.onRequestClicked.bind(this);
  }

  onCancelClicked() {
    this.setState({ displayCancelWarning: true });
  }

  onDeclineClicked() {
    this.setState({ displayDeclineWarning: true });
  }

  onExitPopup() {
    this.setState({
      displayCancelWarning: false,
      displayDeclineWarning: false,
    });
  }

  onInviteClicked() {
    this.props.inviteOnClick();
    //disable the invite button
    this.setState((prevState) => ({
      inviteTitle: CONSTANT.INVITE_SENT,
      buttonClassName: "background_light_med_grey",
      buttonDisabled: true,
    }));
  }

  onRequestClicked() {
    this.props.requestOnClick();
    //disable the invite button
    this.setState({
      requestTitle: CONSTANT.REQUEST_SENT,
      buttonClassName: "background_light_med_grey",
      buttonDisabled: true,
    });
  }

  render() {
    return (
      <div className="page_details_content_main" style={{ marginLeft: "0px" }}>
        <div style={{ paddingTop: "10px", paddingBottom: "20px" }}>
          <div className="friend_motivational_banner_box">
            <div className="text_stack">
              {/* Banner Title and message for when a user has received a friend request.*/}
              {this.props.type === CONSTANT.ARE_YOU_FRIENDS ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.ARE_YOU_FRIENDS + this.props.full_name + "?"
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <div className={"text_xsmall text_med_grey"}>
                    {CONSTANT.ACCEPT_MOTIVATION}
                    <br />
                    <BlockUser
                      username_to_block={this.props.full_name}
                      showAsText={true}
                    />
                  </div>
                </Fragment>
              ) : null}
              {/* Banner Title and message for when a parent is reviewing a friend request.*/}
              {this.props.type === CONSTANT.GUARDIAN_REVIEW ? (
                this.props.reviewChildGroupRequests === true ? (
                  <Fragment>
                    <TextTheme
                      message={
                        "Do you approve your child to join " +
                        this.props.groupName +
                        "?"
                      }
                      className={"text_medium text_bold text_dark_blue"}
                    />
                  </Fragment>
                ) : (
                  <Fragment>
                    <TextTheme
                      message={
                        CONSTANT.DO_YOU_APPROVE + this.props.full_name + "?"
                      }
                      className={"text_medium text_bold text_dark_blue"}
                    />
                    <TextTheme
                      message={CONSTANT.ACCEPT_MOTIVATION}
                      className={"text_xsmall text_med_grey"}
                    />
                    <BlockUser
                      username_to_block={this.props.full_name}
                      blockType={CONSTANT.GUARDIAN_REVIEW}
                    />
                  </Fragment>
                )
              ) : null}
              {/* Banner Title and message when a user canceling a sent friend request.*/}
              {this.props.type === CONSTANT.CANCEL_REQUEST ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.CANCEL_REQUEST + this.props.full_name + "?"
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <TextTheme
                    message={CONSTANT.CANCEL_MESSAGE}
                    className={"text_xsmall text_med_grey"}
                  />
                </Fragment>
              ) : null}
              {/* Banner Title and message when a user is inviting another user to be friends or to join a group.*/}
              {this.props.type === CONSTANT.INVITE_URL ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.INVITE_TITLE + this.props.full_name + "?"
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <TextTheme
                    message={CONSTANT.INVITE_MESSAGE}
                    className={"text_xsmall text_med_grey"}
                  />
                </Fragment>
              ) : this.props.type === CONSTANT.GROUP_INVITE_URL ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.INVITE_TITLE +
                      this.props.full_name +
                      " to " +
                      this.props.groupName +
                      "?"
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <TextTheme
                    message={CONSTANT.NEW_MEMBERS_MESSAGE}
                    className={"text_xsmall text_med_grey"}
                  />
                </Fragment>
              ) : null}
              {/* Banner Title and message when a user has received an invite from a group.*/}
              {this.props.type === CONSTANT.RECEIVED_INVITE_FROM_GROUP ? (
                <Fragment>
                  <TextTheme
                    message={
                      this.props.full_name +
                      CONSTANT.GROUP_RECEIVED_INVITE_MOTIVATION +
                      this.props.groupName +
                      "!"
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <TextTheme
                    message={
                      CONSTANT.ACCEPT_GROUP_MOTIVATION_1 +
                      this.props.groupName +
                      CONSTANT.ACCEPT_GROUP_MOTIVATION_2
                    }
                    className={"text_xsmall text_med_grey"}
                  />
                </Fragment>
              ) : null}
              {/* Banner Title and message when a group has received a request from a user.*/}
              {this.props.type === CONSTANT.RECEIVED_REQUEST ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.GROUP_RECEIVED_REQUEST_TITLE1 +
                      this.props.friendSlug +
                      CONSTANT.GROUP_RECEIVED_REQUEST_TITLE2
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <TextTheme
                    message={
                      CONSTANT.GROUP_RECEIVED_REQUEST_MESSAGE1 +
                      this.props.friendSlug +
                      CONSTANT.GROUP_RECEIVED_REQUEST_MESSAGE2
                    }
                    className={"text_xsmall text_med_grey"}
                  />
                </Fragment>
              ) : null}
              {/* Banner Title and message when a group sent an invitation to a user and seeks to cancel it.*/}
              {this.props.type === CONSTANT.GROUP_MEMBER_REVIEW_URL ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.GROUP_CANCEL_TITLE + this.props.full_name + "?"
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <TextTheme
                    message={
                      CONSTANT.GROUP_INVITE_CANCEL_MESSAGE1 +
                      this.props.full_name +
                      CONSTANT.GROUP_INVITE_CANCEL_MESSAGE2
                    }
                    className={"text_xsmall text_med_grey"}
                  />
                </Fragment>
              ) : null}
              {/* Banner Title and message user can join a public group.*/}
              {this.props.type === CONSTANT.JOIN_GROUP_TITLE ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.JOIN_GROUP_TITLE +
                      " " +
                      this.props.groupName +
                      "?"
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <TextTheme
                    message={
                      this.props.groupName + CONSTANT.JOIN_GROUP_DESCRIPTION
                    }
                    className={"text_xsmall text_med_grey"}
                  />
                </Fragment>
              ) : null}
              {/* Banner Title and message user can request to join a private group.*/}
              {this.props.type === CONSTANT.JOIN_PRIVATE_GROUP ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.JOIN_GROUP_TITLE +
                      " " +
                      this.props.groupName +
                      "?"
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <TextTheme
                    message={
                      this.props.groupName +
                      CONSTANT.JOIN_PRIVATE_GROUP_DESCRIPTION
                    }
                    className={"text_xsmall text_med_grey"}
                  />
                </Fragment>
              ) : null}
              {/* Banner Title and message user can cancel a request they sent to a group.*/}
              {this.props.type === CONSTANT.GROUP_CANCEL_REQUEST_TITLE ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.GROUP_CANCEL_REQUEST_TITLE +
                      " " +
                      this.props.groupName +
                      "?"
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                  <TextTheme
                    message={
                      CONSTANT.GROUP_REQUEST_CANCEL_MESSAGE1 +
                      this.props.groupName +
                      CONSTANT.GROUP_REQUEST_CANCEL_MESSAGE2
                    }
                    className={"text_xsmall text_med_grey"}
                  />
                </Fragment>
              ) : this.props.type === CONSTANT.REQUEST_SENT ? (
                <Fragment>
                  <TextTheme
                    message={
                      CONSTANT.REQUEST_SENT_MESSAGE + this.props.friendSlug + '.'
                    }
                    className={"text_medium text_bold text_dark_blue"}
                  />
                </Fragment>
              ) : null}
            </div>
            {this.props.type === CONSTANT.CANCEL_REQUEST ||
            this.props.type === CONSTANT.GROUP_MEMBER_REVIEW_URL ||
            this.props.type === CONSTANT.GROUP_CANCEL_REQUEST_TITLE ? (
              <Fragment>
                <div className="cancel_invite_button">
                  <RoundedButton
                    textThemeClassName="text_small text_white text_bold"
                    buttonClassName="background_dark_orange"
                    //handleOnClick={this.props.cancelOnClick}
                    handleOnClick={this.onCancelClicked}
                    title={CONSTANT.BUTTON_CANCEL}
                    borderRadius="6px"
                  />
                </div>
                {this.state.displayCancelWarning ? (
                  this.props.type === CONSTANT.GROUP_MEMBER_REVIEW_URL ? (
                    <CustomDecisionPopup
                      popupTitle={
                        CONSTANT.GROUP_CANCEL_TITLE +
                        this.props.full_name +
                        "?"
                      }
                      popupDescription={CONSTANT.GROUP_CANCEL_WARNING1}
                      popupDescription2={
                        CONSTANT.GROUP_CANCEL_WARNING2 +
                        this.props.full_name +
                        "."
                      }
                      acceptButtonText={CONSTANT.ACCEPT_CANCEL_INVITATION}
                      declineButtonText={CONSTANT.DECLINE_CANCEL}
                      acceptButtonClick={this.props.cancelOnClick}
                      declineButtonClick={this.onExitPopup}
                    />
                  ) : this.props.type === CONSTANT.CANCEL_REQUEST ? (
                    <CustomDecisionPopup
                      popupTitle={
                        CONSTANT.CANCEL_TITLE + this.props.full_name + "?"
                      }
                      popupDescription={
                        CONSTANT.CANCEL_WARNING1 +
                        this.props.full_name +
                        CONSTANT.CANCEL_WARNING2
                      }
                      acceptButtonText={CONSTANT.ACCEPT_CANCEL}
                      declineButtonText={CONSTANT.DECLINE_CANCEL}
                      acceptButtonClick={this.props.cancelOnClick}
                      declineButtonClick={this.onExitPopup}
                    />
                  ) : this.props.type ===
                    CONSTANT.GROUP_CANCEL_REQUEST_TITLE ? (
                    <CustomDecisionPopup
                      popupTitle={
                        CONSTANT.GROUP_CANCEL_REQUEST_TITLE +
                        this.props.groupName +
                        "?"
                      }
                      popupDescription={CONSTANT.GROUP_CANCEL_REQUEST_WARNING1}
                      acceptButtonText={CONSTANT.ACCEPT_CANCEL}
                      declineButtonText={CONSTANT.DECLINE_CANCEL}
                      acceptButtonClick={this.props.cancelOnClick}
                      declineButtonClick={this.onExitPopup}
                    />
                  ) : null
                ) : null}
              </Fragment>
            ) : this.props.type === CONSTANT.INVITE_URL ||
              this.props.type === CONSTANT.GROUP_INVITE_URL ? (
              <div className="cancel_invite_button">
                <RoundedButton
                  textThemeClassName="text_small text_white text_bold"
                  buttonClassName={this.state.buttonClassName}
                  handleOnClick={this.onInviteClicked}
                  title={this.state.inviteTitle}
                  disabled={this.state.buttonDisabled}
                  borderRadius="6px"
                />
              </div>
            ) : this.props.type === CONSTANT.JOIN_GROUP_TITLE ? (
              <div className="cancel_invite_button">
                <RoundedButton
                  textThemeClassName="text_small text_white text_bold"
                  buttonClassName="background_dark_orange"
                  handleOnClick={this.props.joinOnClick}
                  title={CONSTANT.JOIN}
                  borderRadius="6px"
                />
              </div>
            ) : this.props.type === CONSTANT.JOIN_PRIVATE_GROUP ? (
              <div className="cancel_invite_button">
                <RoundedButton
                  textThemeClassName="text_small text_white text_bold"
                  buttonClassName={this.state.buttonClassName}
                  handleOnClick={this.onRequestClicked}
                  title={this.state.requestTitle}
                  disabled={this.state.buttonDisabled}
                  borderRadius="6px"
                />
              </div>
            ) : this.props.type === CONSTANT.REQUEST_SENT ? (
              <></>
            ) : (
              <div className={"accept_decline"}>
                <TwoButtonLayout
                  button1Text={CONSTANT.DECLINE}
                  button2Text={CONSTANT.ACCEPT}
                  button1Click={this.onDeclineClicked}
                  button2Click={this.props.acceptOnClick}
                />
                {this.state.displayDeclineWarning ? (
                  this.props.type === CONSTANT.RECEIVED_INVITE_FROM_GROUP ? (
                    <CustomDecisionPopup
                      popupTitle={
                        CONSTANT.DECLINE +
                        " " +
                        this.props.full_name +
                        CONSTANT.GROUP_DECLINE_TITLE +
                        this.props.groupName +
                        "?"
                      }
                      popupDescription={CONSTANT.GROUP_DECLINE_WARNING}
                      acceptButtonText={CONSTANT.ACCEPT_DECLINE}
                      declineButtonText={CONSTANT.DECLINE_BLOCK}
                      acceptButtonClick={this.props.declineOnClick}
                      declineButtonClick={this.onExitPopup.bind(this)}
                    />
                  ) : this.props.type === CONSTANT.RECEIVED_REQUEST ? (
                    <CustomDecisionPopup
                      popupTitle={
                        CONSTANT.GROUP_DECLINE_RECEIVED_REQUEST_TITLE +
                        this.props.full_name +
                        "?"
                      }
                      popupDescription={
                        CONSTANT.GROUP_DECLINE_RECEIVED_REQUEST_WARNING
                      }
                      acceptButtonText={
                        CONSTANT.ACCEPT_DECLINE_RECEIVED_REQUEST
                      }
                      declineButtonText={CONSTANT.DECLINE_BLOCK}
                      acceptButtonClick={this.props.declineOnClick}
                      declineButtonClick={this.onExitPopup.bind(this)}
                    />
                  ) : this.props.type === CONSTANT.ARE_YOU_FRIENDS ? (
                    <CustomDecisionPopup
                      popupTitle={
                        CONSTANT.DECLINE_TITLE + this.props.full_name + "?"
                      }
                      popupDescription={
                        CONSTANT.DECLINE_WARNING1 +
                        this.props.full_name +
                        CONSTANT.DECLINE_WARNING2
                      }
                      acceptButtonText={CONSTANT.ACCEPT_DECLINE}
                      declineButtonText={CONSTANT.DECLINE_BLOCK}
                      acceptButtonClick={this.props.declineOnClick}
                      declineButtonClick={this.onExitPopup.bind(this)}
                    />
                  ) : this.props.type === CONSTANT.GUARDIAN_REVIEW ? (
                    <CustomDecisionPopup
                      popupTitle={
                        this.props.isGroup
                          ? CONSTANT.DECLINE_CHILD_GROUP_REQUESTS_TITLE +
                            this.props.groupName +
                            "?"
                          : CONSTANT.DECLINE_CHILD_FRIEND_REQUESTS_TITLE +
                            this.props.full_name +
                            "?"
                      }
                      popupDescription={
                        this.props.isGroup
                          ? CONSTANT.DECLINE_CHILD_GROUP_REQUESTS_WARNING1 +
                            this.props.groupName +
                            "? " +
                            CONSTANT.DECLINE_CHILD_GROUP_REQUESTS_WARNING2
                          : CONSTANT.DECLINE_CHILD_FRIEND_REQUESTS_WARNING1 +
                            this.props.full_name +
                            "? " +
                            CONSTANT.DECLINE_CHILD_FRIEND_REQUESTS_WARNING2
                      }
                      acceptButtonText={CONSTANT.ACCEPT_DECLINE}
                      declineButtonText={CONSTANT.DECLINE_BLOCK}
                      acceptButtonClick={this.props.declineOnClick}
                      declineButtonClick={this.onExitPopup.bind(this)}
                    />
                  ) : null
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default FriendMotivationalBanner;
